"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoggerForClientAndServerUtilitiesPackage = exports.logWarning = exports.logNotice = exports.logInfo = exports.logError = exports.logDebug = exports.logCritical = exports.getLoggerForClientAndServerUtilitiesPackage = exports.defaultUnserializableConstructors = exports.HpWebRequestError = void 0;
var _loggingAndErrors = require("@avantia/logging-and-errors");
var _http = require("http");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const logger = (0, _loggingAndErrors.createIsolatedPackageLogger)();
const defaultUnserializableConstructors = Object.freeze([_http.IncomingMessage, _http.ServerResponse]);
exports.defaultUnserializableConstructors = defaultUnserializableConstructors;
(0, _loggingAndErrors.setUnserializableConstructorList)([...defaultUnserializableConstructors]);
const {
  debug: logDebug,
  info: logInfo,
  notice: logNotice,
  warn: logWarning,
  error: logError,
  critical: logCritical,
  setLogger: setLoggerForClientAndServerUtilitiesPackage,
  getLogger: getLoggerForClientAndServerUtilitiesPackage
} = logger;
exports.getLoggerForClientAndServerUtilitiesPackage = getLoggerForClientAndServerUtilitiesPackage;
exports.setLoggerForClientAndServerUtilitiesPackage = setLoggerForClientAndServerUtilitiesPackage;
exports.logCritical = logCritical;
exports.logError = logError;
exports.logWarning = logWarning;
exports.logNotice = logNotice;
exports.logInfo = logInfo;
exports.logDebug = logDebug;
class HpWebRequestError extends _loggingAndErrors.HpError {
  constructor(props) {
    super(props.message);
    _defineProperty(this, "statusCode", void 0);
    _defineProperty(this, "responseData", void 0);
    _defineProperty(this, "url", void 0);
    _defineProperty(this, "method", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "timeTaken", void 0);
    const {
      timer,
      request
    } = props;
    const {
      method,
      url,
      description
    } = request;
    this.name = 'HpWebRequestError';
    this.url = url;
    this.method = method;
    this.description = description;
    this.timeTaken = timer.elapsedTimeAsString();
  }
}
exports.HpWebRequestError = HpWebRequestError;